import { c as _c } from "react/compiler-runtime";
import { Form } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import type { CardFormData } from '../types';
import { isCardCvcValid, isCardExpired, isCardExpiryValid } from '../utils/validations';
type CvcAndExpiryFieldsProps = {
  collectsCvc: boolean;
  collectsExpiry: boolean;
  numDigits: 3 | 4;
  clearServerError: (fieldName: keyof CardFormData) => void;
};
const CvcAndExpiryFields = t0 => {
  const $ = _c(17);
  const {
    collectsCvc,
    collectsExpiry,
    numDigits,
    clearServerError
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectCardData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  if (!collectsCvc && !collectsExpiry) {
    return null;
  }
  const t2 = collectsCvc && collectsExpiry;
  const t3 = !(collectsCvc || !collectsExpiry);
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = cx("grid gap-4", {
      "grid-cols-1 md:grid-cols-2": t2,
      "grid-cols-1": t3
    });
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== clearServerError || $[5] !== collectsCvc || $[6] !== numDigits || $[7] !== t) {
    t5 = collectsCvc && <Form.Input name="cvc" label={t(_temp)} autoComplete="cc-csc" className="fp-input-cvc" data-dd-privacy="mask" inputMode="numeric" mask={{
      numericOnly: true,
      blocks: [numDigits]
    }} placeholder={numDigits === 3 ? "123" : "1234"} rules={{
      required: t(_temp2),
      validate: {
        validCvc: value => isCardCvcValid(value, numDigits) || t(_temp3)
      },
      onChange: () => clearServerError("cvc")
    }} />;
    $[4] = clearServerError;
    $[5] = collectsCvc;
    $[6] = numDigits;
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== clearServerError || $[10] !== collectsExpiry || $[11] !== t) {
    t6 = collectsExpiry && <Form.Input name="expiry" label={t(_temp4)} autoComplete="cc-exp" className="fp-input-exp-date" data-dd-privacy="mask" inputMode="numeric" mask={{
      date: true,
      datePattern: ["m", "y"],
      delimiter: "/"
    }} placeholder="MM / YY" rules={{
      required: t(_temp5),
      validate: {
        validExpiry: value_0 => {
          if (!isCardExpiryValid(value_0)) {
            if (isCardExpired(value_0)) {
              return t(_temp6);
            }
            return t(_temp7);
          }
          return true;
        }
      },
      onChange: () => clearServerError("expiry")
    }} />;
    $[9] = clearServerError;
    $[10] = collectsExpiry;
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default CvcAndExpiryFields;
function _temp($) {
  return $.form.cvc.label;
}
function _temp2($_0) {
  return $_0.form.cvc.errors.required;
}
function _temp3($_1) {
  return $_1.form.cvc.errors.invalid;
}
function _temp4($_2) {
  return $_2.form.expiry.label;
}
function _temp5($_3) {
  return $_3.form.expiry.errors.required;
}
function _temp6($_4) {
  return $_4.form.expiry.errors.expired;
}
function _temp7($_5) {
  return $_5.form.expiry.errors.invalid;
}